import { motion, AnimatePresence } from "motion/react";
import styles from "./EvaluationFooter.module.css";
import tickIcon from "@assets/icons/charm-tick.svg";

interface EvaluationFooterProps {
  questionIndex: number;
  totalQuestions: number;
  approvalValid: boolean;
  isSaving: boolean;
  onPrevious: () => void;
  onApproveAndSubmit: () => void;
  onApproveAndNext: () => void;
}

function EvaluationFooter({
  questionIndex,
  totalQuestions,
  approvalValid,
  isSaving,
  onPrevious,
  onApproveAndSubmit,
  onApproveAndNext,
}: EvaluationFooterProps) {
  const isLastQuestion = questionIndex === totalQuestions - 1;

  return (
    <div>
      <motion.div className={styles.evaluatorFooter} layout>
        <AnimatePresence>
          {questionIndex > 0 && (
            <motion.button
              key="previous"
              className={styles.previousButton}
              onClick={onPrevious}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              layout
              transition={{
                type: "spring",
                stiffness: 300,
                damping: 25,
              }}
            >
              Previous
            </motion.button>
          )}
        </AnimatePresence>
        {isLastQuestion ? (
          <motion.button
            key="approve-submit"
            className={styles.approvalButton}
            onClick={onApproveAndSubmit}
            disabled={!approvalValid || isSaving}
            layout
            whileHover="hover"
            initial="initial"
          >
            {isSaving ? (
              <motion.div
                className={styles.spinner}
                animate={{ rotate: 360 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 15,
                  repeat: Infinity,
                  duration: 0.8,
                }}
              />
            ) : (
              <motion.img
                src={tickIcon}
                alt="Tick Icon"
                variants={
                  approvalValid
                    ? {
                        initial: { scale: 1 },
                        hover: {
                          scale: 1.2,
                          transition: {
                            type: "spring",
                            stiffness: 300,
                            damping: 20,
                          },
                        },
                      }
                    : {
                        initial: { scale: 1 },
                        hover: { scale: 1 },
                      }
                }
              />
            )}
            Approve & Submit
          </motion.button>
        ) : (
          <motion.button
            key="approve-next"
            className={styles.approvalButton}
            onClick={onApproveAndNext}
            disabled={!approvalValid || isSaving}
            layout
            whileHover="hover"
            initial="initial"
          >
            {isSaving ? (
              <motion.div
                className={styles.spinner}
                animate={{ rotate: 360 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 15,
                  repeat: Infinity,
                  duration: 0.8,
                }}
              />
            ) : (
              <motion.img
                src={tickIcon}
                alt="Tick Icon"
                variants={
                  approvalValid
                    ? {
                        initial: { scale: 1 },
                        hover: {
                          scale: 1.2,
                          transition: {
                            type: "spring",
                            stiffness: 300,
                            damping: 20,
                          },
                        },
                      }
                    : {
                        initial: { scale: 1 },
                        hover: { scale: 1 },
                      }
                }
              />
            )}
            Approve & Next
          </motion.button>
        )}
      </motion.div>
    </div>
  );
}

export default EvaluationFooter;
